module.exports = __webpack_public_path__ + "img/ft_peas.fcf19a18.jpg";